import {
  TIMESLOT_ERROR,
  EDIT_TIMESLOT_SUCCESS,
  GET_TIMESLOT
} from "../constants/timeslotConstants";

const initialState = {
  timeslot: null,
  loading: true
};

export const requestTimeslot = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_TIMESLOT:
      return Object.assign({}, state, {
        timeslot: action.payload,
        loading: false
      });
    case TIMESLOT_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export const editTimeslot = (state = initialState, action = {}) => {
  switch (action.type) {
    case EDIT_TIMESLOT_SUCCESS:
      return Object.assign({}, state, {
        timeslot: action.payload
      });
    default:
      return state;
  }
};
